import React from 'react';

import { SvgIconProps } from '@material-ui/core';

interface PlannedOutageIconProps extends Omit<SvgIconProps, 'color'> {
  text: string | number;
  title?: string;
  size?: number;
}

const PlannedOutageClusterIcon: React.FC<PlannedOutageIconProps> = ({
  text,
  title = '',
  size = 32,
  ...props
}) => {
  const shadow = `drop-shadow(0px 0px ${size * 0.15}px rgba(0,0,0,0.5))`;
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="9 14 30 22"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: shadow }}
    >
      <g>
        {title && <title>{title}</title>}
        <path
          d="M21.8564 11.5361C23.0167 10.8663 24.4293 10.8241 25.6211 11.4102L25.8564 11.5361L34.7129 16.6494C35.9504 17.364 36.7129 18.6843 36.7129 20.1133V30.3398C36.7129 31.7688 35.9504 33.0892 34.7129 33.8037L25.8564 38.917C24.6962 39.5868 23.2836 39.629 22.0918 39.043L21.8564 38.917L13 33.8037C11.7625 33.0892 11 31.7688 11 30.3398V20.1133C11 18.6843 11.7625 17.364 13 16.6494L21.8564 11.5361Z"
          fill="#004680"
          stroke="white"
          strokeWidth="2"
        />
        <text
          x="24"
          y="27"
          fill="white"
          fontSize="11"
          fontWeight="bold"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {text}
        </text>
      </g>
    </svg>
  );
};

export default PlannedOutageClusterIcon;
